import React, { useState } from 'react';
import styles from './HelpGuide.module.css';

const HelpGuide = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      title: "¡Bienvenido al Mapa de Abogacía UBA! 🎓",
      content: (
        <div>
          <p>Esta herramienta te ayuda a planificar tu carrera de Derecho paso a paso.</p>
          <p>Te permite:</p>
          <ul>
            <li>✅ Marcar materias cursadas y aprobadas</li>
            <li>📊 Ver tu progreso en tiempo real</li>
            <li>🔗 Entender las correlatividades</li>
            <li>🎯 Planificar tu orientación</li>
            <li>💾 Guardar tu progreso</li>
          </ul>
        </div>
      )
    },
    {
      title: "📱 Mapa (gestos y controles)",
      content: (
        <div>
          <p><strong>Gestos:</strong> Pellizcá para acercar/alejar. Arrastrá para moverte. Doble toque para encuadrar.</p>
          <p><strong>Botones:</strong> Usá (− / + / ⤢) abajo a la derecha para zoom y encuadrar.</p>
          <p style={{marginTop: '12px'}}>CBC no se muestra. Desbloqueos automáticos según correlativas.</p>
          <a href="#atajos" style={{ color: 'var(--accent-color)' }}>Ver atajos y gestos</a>
        </div>
      )
    },
    {
      title: "📚 Materias (reglas clave)",
      content: (
        <div>
          <ul>
            <li>Notas enteras 4–10.</li>
            <li>Lectocomprensión y Práctico Profesional: “Aprobado” sin nota.</li>
            <li>Exportá CSV desde la lista visible. Mes/Año solo para finales.</li>
          </ul>
        </div>
      )
    },
    {
      title: "🗓️ Agenda (cursadas y eventos)",
      content: (
        <div>
          <ul>
            <li>Cursadas (ej: Lu/Vi 17–19) y Eventos (Parcial/Final/TP).</li>
            <li>Arrastrable (eventos únicos). Exportar CSV/ICS, importar CSV/ICS.</li>
            <li>Tus datos viven en tu navegador (sin cuentas).</li>
          </ul>
        </div>
      )
    },
    {
      title: "🔐 Privacidad y ayuda",
      content: (
        <div>
          <p>Sin login. Persistencia en tu dispositivo (localStorage).</p>
          <p>¿Problemas con cursadas?: revisá días/horas y rango del cuatrimestre, y usá ⤢ para encuadrar. Probá “Limpiar Agenda” y reimportar.</p>
        </div>
      )
    },
    {
      title: "🔗 Explorando Correlatividades",
      content: (
        <div>
          <p>Para ver las correlatividades de una materia:</p>
          <ol>
            <li>🖱️ Hacé <strong>click derecho</strong> en una materia (o doble tap en móvil)</li>
            <li>🟡 Verás en <span style={{color: 'var(--warning-color)'}}>amarillo</span> qué materias necesitás antes</li>
            <li>🟢 Verás en <span style={{color: 'var(--success-color)'}}>verde</span> qué materias habilita</li>
            <li>❌ Click de nuevo para salir del modo exploración</li>
          </ol>
          <p style={{color: 'var(--text-secondary)', fontSize: '0.9em', marginTop: '15px'}}>
            💡 Esto es súper útil para planificar qué materias cursar cada cuatrimestre
          </p>
        </div>
      )
    },
    {
      title: "🎯 Orientaciones y CPO",
      content: (
        <div>
          <p>Cuando llegues al CPO (Ciclo Profesional Orientado):</p>
          <ol>
            <li>CPO Hacé click en el <strong>botón CPO</strong> (naranja) en el header</li>
            <li>📋 Elegí tu orientación preferida del dropdown</li>
            <li>📊 Cargá las materias que vas cursando</li>
            <li>🏆 Seguí tu progreso de puntos</li>
          </ol>
          <p style={{color: 'var(--accent-color)', fontWeight: 'bold'}}>
            Necesitás 69 puntos CPO para recibir + materias obligatorias
          </p>
          <div style={{marginTop: '15px', padding: '12px', backgroundColor: 'var(--bg-hover)', borderRadius: '8px', fontSize: '0.9em'}}>
            <strong>📍 Ubicación:</strong> El botón CPO está en la parte superior derecha, junto a los botones de ayuda (❓) y configuración (⚙️)
          </div>
        </div>
      )
    },
    {
      title: "💾 Guardá tu Progreso",
      content: (
        <div>
          <p><strong>Tu progreso se guarda automáticamente</strong> en tu navegador, pero también podés:</p>
          <ul>
            <li>📥 <strong>Descargar backup:</strong> Archivo para guardar en Drive/Dropbox</li>
            <li>📋 <strong>Copiar al portapapeles:</strong> Para pegarlo en un documento</li>
            <li>📤 <strong>Restaurar backup:</strong> Si cambiás de computadora</li>
          </ul>
          <p style={{color: 'var(--error-color)', fontSize: '0.9em'}}>
            ⚠️ Si borrás datos del navegador, perdés el progreso. ¡Hacé backup regularmente!
          </p>
        </div>
      )
    },
    {
      title: "🚀 Tips para Estudiantes",
      content: (
        <div>
          <p><strong>Consejos de uso:</strong></p>
          <ul>
            <li>🎓 <strong>Empezá con el CBC:</strong> Hacé click en el rectángulo rojo para aprobar todo</li>
            <li>📅 <strong>Planificá cuatrimestres:</strong> Usá el modo exploración para ver qué podés cursar</li>
            <li>📊 <strong>Seguí tu progreso:</strong> El panel de estadísticas te motiva</li>
            <li>🔄 <strong>Actualizá regularmente:</strong> Marcá materias apenas las apruebes</li>
            <li>💬 <strong>Compartí con amigos:</strong> Pueden comparar progresos</li>
          </ul>
          <p style={{color: 'var(--success-color)', fontWeight: 'bold', textAlign: 'center', marginTop: '20px'}}>
            🎉 ¡Éxitos en tu carrera de Derecho!
          </p>
        </div>
      )
    }
  ];

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.header}>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              background: 'rgba(255, 255, 255, 0.2)',
              border: 'none',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              color: 'white',
              cursor: 'pointer',
              fontSize: '18px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ✕
          </button>
          <h2 style={{ margin: 0, fontSize: '1.4em', paddingRight: '50px' }}>{steps[currentStep].title}</h2>
          <div style={{ marginTop: '8px', fontSize: '0.9em', opacity: 0.9 }}>
            Paso {currentStep + 1} de {steps.length}
          </div>
        </div>

        <div className={styles.progressBar}>
          <div style={{
            height: '100%',
            backgroundColor: 'var(--success-color)',
            width: `${((currentStep + 1) / steps.length) * 100}%`,
            transition: 'width 0.3s ease'
          }} />
        </div>

        <div className={styles.content}>
          {steps[currentStep].content}
        </div>

        <div className={styles.footer}>
          <button
            onClick={prevStep}
            disabled={currentStep === 0}
            style={{
              padding: '10px 20px',
              backgroundColor: currentStep === 0 ? 'var(--text-muted)' : 'var(--text-secondary)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: currentStep === 0 ? 'not-allowed' : 'pointer',
              fontSize: '0.9em'
            }}
          >
            ← Anterior
          </button>

          <div style={{
            display: 'flex',
            gap: '8px'
          }}>
            {steps.map((step, index) => (
              <div
                key={step.title}
                style={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  backgroundColor: index === currentStep ? 'var(--accent-color)' : 'var(--border-color)',
                  transition: 'all 0.3s ease'
                }}
              />
            ))}
          </div>

          {currentStep === steps.length - 1 ? (
            <button
              onClick={onClose}
              style={{
                padding: '10px 20px',
                backgroundColor: 'var(--success-color)',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '0.9em',
                fontWeight: 'bold'
              }}
            >
              ¡Empezar! 🚀
            </button>
          ) : (
            <button
              onClick={nextStep}
              style={{
                padding: '10px 20px',
                backgroundColor: 'var(--accent-color)',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '0.9em'
              }}
            >
              Siguiente →
            </button>
          )}
        </div>

        {/* Nueva sección: Sobre el Proyecto */}
        {currentStep === steps.length - 1 && (
          <div style={{marginTop: '20px', padding: '12px', backgroundColor: 'var(--bg-hover)', borderRadius: '6px', border: '1px solid var(--accent-color)'}}>
            <h4 style={{color: 'var(--accent-color)', margin: '0 0 8px 0', fontSize: '1em'}}>
              📚 Sobre este Proyecto
            </h4>
            <p style={{margin: '0 0 8px 0', fontSize: '0.85em'}}>
              Creado por <strong>Sebastian Soto</strong>, estudiante de Derecho UBA. 
              Proyecto sin fines de lucro, pensado por y para estudiantes.
            </p>
            <div style={{textAlign: 'center', marginTop: '10px'}}>
              <a 
                href="mailto:soto127@est.derecho.uba.ar" 
                style={{
                  backgroundColor: 'var(--success-color)',
                  color: 'white',
                  padding: '6px 12px',
                  borderRadius: '4px',
                  textDecoration: 'none',
                  fontSize: '0.8em',
                  fontWeight: '500',
                  display: 'inline-block',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.opacity = '0.9'}
                onMouseOut={(e) => e.target.style.opacity = '1'}
              >
                📧 Contacto UBA
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpGuide; 